import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "fapiaoOrderDetail__content" }
const _hoisted_2 = { class: "detail" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, "发票编号", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, "发票抬头", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "发票类型", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "开票类型", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "发票号", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "申请开票金额", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, "企业开户银行", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "企业银行账号", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "企业注册地址", -1)
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, "企业固定电话", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "发票申请时间", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, "发票状态", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "发票申请人", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, "发票内容", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, "规格型号", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, "单位", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "数量", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "单价", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, "金额（元）", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, "税率", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, "税额（元）", -1)
const _hoisted_27 = { class: "detail" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, "价税合计 (元)", -1)
const _hoisted_29 = { colspan: "3" }
const _hoisted_30 = { class: "detail" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, "邮寄状态", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, "快递名称", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, "邮寄日期", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_36 = { class: "detail" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, "邮箱地址", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", null, "邮件发送时间", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, "邮件发送次数", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_section = _resolveComponent("app-section")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    class: "fapiaoOrderDetail",
    title: "发票详情",
    placement: "right",
    "mask-closable": true,
    width: 800
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_app_section, { title: "发票信息" }, {
          default: _withCtx(() => [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("tr", null, [
                _hoisted_3,
                _createElementVNode("td", null, _toDisplayString(_ctx.detailData.invoiceNo), 1),
                _hoisted_4,
                _createElementVNode("td", null, _toDisplayString(_ctx.detailData.invoiceTitle || '---'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_5,
                _createElementVNode("td", null, _toDisplayString(_ctx.invoiceTypeMap[_ctx.detailData.invoiceType] || '---'), 1),
                _hoisted_6,
                _createElementVNode("td", null, _toDisplayString(_ctx.detailData.invoiceRedTypeStr), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_7,
                _createElementVNode("td", null, _toDisplayString(_ctx.detailData.oilInvoiceNo), 1),
                _hoisted_8,
                _createElementVNode("td", null, _toDisplayString(_ctx.formatWithIntl(_ctx.detailData.applyInvoiceTotalFee)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_9,
                _createElementVNode("td", null, _toDisplayString(_ctx.detailData.accountBank), 1),
                _hoisted_10,
                _createElementVNode("td", null, _toDisplayString(_ctx.detailData.accountNo), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", {
                  title: _ctx.detailData.registAddress,
                  class: "ellipsis"
                }, _toDisplayString(_ctx.detailData.registAddress), 9, _hoisted_12),
                _hoisted_13,
                _createElementVNode("td", null, _toDisplayString(_ctx.detailData.registTel), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", null, _toDisplayString(_ctx.detailData.applyDate), 1),
                _hoisted_15,
                _createElementVNode("td", null, _toDisplayString(_ctx.invoiceStatusMap[_ctx.detailData.oilInvoiceStatus] || _ctx.detailData.oilInvoiceStatusStr), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_16,
                _createElementVNode("td", null, _toDisplayString(_ctx.detailData.applyUser) + " - " + _toDisplayString(_ctx.detailData.applyPhone ? _ctx.detailData.applyPhone.slice(-4) : ''), 1),
                _hoisted_17,
                _hoisted_18
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_app_section, { title: "发票内容" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.contents, (item) => {
              return (_openBlock(), _createElementBlock("table", {
                key: item.invoiceContent,
                class: "detail"
              }, [
                _createElementVNode("tr", null, [
                  _hoisted_19,
                  _createElementVNode("td", null, _toDisplayString(item.invoiceContent || '---'), 1),
                  _hoisted_20,
                  _createElementVNode("td", null, _toDisplayString(item.goodsSpecification || '---'), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_21,
                  _createElementVNode("td", null, _toDisplayString(item.goodsUnit || '---'), 1),
                  _hoisted_22,
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatWithIntl(item.goodsQuantity)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_23,
                  _createElementVNode("td", null, _toDisplayString(item.goodsPrice), 1),
                  _hoisted_24,
                  _createElementVNode("td", null, _toDisplayString(item.goodsTotalPrice), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_25,
                  _createElementVNode("td", null, _toDisplayString(item.goodsTaxRate), 1),
                  _hoisted_26,
                  _createElementVNode("td", null, _toDisplayString(item.invoiceTotalTax), 1)
                ])
              ]))
            }), 128)),
            _createElementVNode("table", _hoisted_27, [
              _createElementVNode("tr", null, [
                _hoisted_28,
                _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.detailData.invoiceTotalPriceTax), 1)
              ])
            ])
          ]),
          _: 1
        }),
        (_ctx.detailData.invoiceType === '1')
          ? (_openBlock(), _createBlock(_component_app_section, {
              key: 0,
              title: "邮寄信息"
            }, {
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_30, [
                  _createElementVNode("tr", null, [
                    _hoisted_31,
                    _createElementVNode("td", null, _toDisplayString(_ctx.detailData.mailingStatusStr), 1),
                    _hoisted_32,
                    _createElementVNode("td", null, _toDisplayString(_ctx.detailData.expressName), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_33,
                    _createElementVNode("td", null, _toDisplayString(_ctx.detailData.mailingTime), 1),
                    _hoisted_34,
                    _hoisted_35
                  ])
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_app_section, {
              key: 1,
              title: "邮寄信息"
            }, {
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_36, [
                  _createElementVNode("tr", null, [
                    _hoisted_37,
                    _createElementVNode("td", null, _toDisplayString(_ctx.detailData.email), 1),
                    _hoisted_38,
                    _createElementVNode("td", null, _toDisplayString(_ctx.detailData.emailTime), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_39,
                    _createElementVNode("td", null, _toDisplayString(_ctx.detailData.mailTimes), 1),
                    _hoisted_40,
                    _hoisted_41
                  ])
                ])
              ]),
              _: 1
            })),
        false
          ? (_openBlock(), _createBlock(_component_app_section, {
              key: 2,
              title: "订单日志"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  ref: "table",
                  size: "large",
                  "row-key": "uid",
                  columns: _ctx.tableColumns,
                  "data-source": _ctx.tableData,
                  "show-pagination": true
                }, {
                  action: _withCtx(() => [
                    _createVNode(_component_router_link, { to: {name: 'order.oil.detail', params: {id: 0} } }, {
                      default: _withCtx(() => [
                        _createTextVNode("详情")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                }, 8, ["columns", "data-source"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}